import { createActionConst } from '../../../../utils/action.utils';

const CHART_NAMESPACE = 'CHARTS';

export const STORE_IS_FETCHED = createActionConst(CHART_NAMESPACE, 'STORE_IS_FETCHED');
export const CLEAR_IS_FETCHED = createActionConst(CHART_NAMESPACE, 'CLEAR_IS_FETCHED');

export const STORE_CHART = createActionConst(CHART_NAMESPACE, 'STORE_CHART');
export const CLEAR_CHART = createActionConst(CHART_NAMESPACE, 'CLEAR_CHART');

export const REFRESH_CHART = createActionConst(CHART_NAMESPACE, 'REFRESH_CHART');
export const CLEAR_REFRESH_CHART = createActionConst(CHART_NAMESPACE, 'CLEAR_REFRESH_CHART');

export const STORE_CHART_VERSIONS = createActionConst(CHART_NAMESPACE, 'STORE_CHART_VERSIONS');
export const SET_SELECTED_CHART_ID = createActionConst(CHART_NAMESPACE, 'SET_SELECTED_CHART_ID');
export const SET_DRAFT_SELECTED = createActionConst(CHART_NAMESPACE, 'SET_DRAFT_SELECTED');
export const CLEAR_CHART_EDIT_STATE = createActionConst(CHART_NAMESPACE, 'CLEAR_CHART_EDIT_STATE');

export const SAVE_CHART_SOCKET = 'saveChart';
